import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    const flagSvg = `
        <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1883_59151)">
            <path d="M0 16H32V24H0V16Z" fill="#FFCE00"/>
            <path d="M0 0H32V8H0V0Z" fill="#000001"/>
            <path d="M0 8H32V16H0V8Z" fill="#FF0000"/>
            </g>
            <defs>
            <clipPath id="clip0_1883_59151">
            <path d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V20C32 22.2091 30.2091 24 28 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    `;

    blockManager.add('language-switcher', {
        label: 'Sprachumschalter',
        category: blockCategories.advance,
        content: {
            type: 'language-switcher',
            classes: ['language-switcher'],
        },
        media: `
            <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#e3e3e3">
                <path d="m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z"/>
            </svg>
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('language-switcher', {
        model: {
            defaults: {
                ...defaultModel.prototype.defaults,
                tagName: 'div',
                classes: ['language-switcher'],
                droppable: false,
                components: `${flagSvg}Deutsch`,
                view: 'dropdown',
                display: 'languageName',
                showFlag: true,
                traits: [
                    {
                        type: 'select',
                        label: 'Sicht',
                        name: 'view',
                        options: [
                            {
                                name: 'Dropdown',
                                value: 'dropdown',
                            },
                            {
                                name: 'Modal',
                                value: 'modal',
                            },
                            {
                                name: 'List',
                                value: 'list',
                            },
                        ],
                        default: 'dropdown',
                        changeProp: 1,
                    },
                    {
                        type: 'select',
                        label: 'Anzeige',
                        name: 'display',
                        options: [
                            {
                                name: 'Sprache',
                                value: 'languageName',
                            },
                            {
                                name: 'Sprachcode',
                                value: 'languageCode',
                            },
                        ],
                        default: 'languageName',
                        changeProp: 1,
                    },
                    {
                        type: 'checkbox',
                        label: 'Flagge anzeigen',
                        name: 'showFlag',
                        changeProp: 1,
                        value: true,
                    },
                    {
                        type: 'checkbox',
                        label: 'Pfeil anzeigen',
                        name: 'showArrow',
                        changeProp: 1,
                        value: true,
                    },
                ],
                style: {
                    display: 'flex',
                    'align-items': 'center',
                    gap: '8px',
                },
            },

            init() {
                this.on(
                    'change:display change:showFlag change:showArrow',
                    this.updateContent
                );

                this.updateContent();
            },

            updateContent() {
                const display = this.get('display');
                const showFlag = this.get('showFlag');
                const showArrow = this.get('showArrow');

                const flag = showFlag ? flagSvg : '';
                const text = display === 'languageCode' ? 'DE' : 'Deutsch';
                const arrow = showArrow ? '&#9662;' : '';

                this.components(`${flag}${text}${arrow}`);
            },
        },

        isComponent(el) {
            if (
                el &&
                el.classList &&
                el.classList.contains('language-switcher')
            ) {
                return {
                    type: 'language-switcher',
                };
            }
        },

        view: defaultView,
    });
};
